export default __webpack_public_path__ + "static/flexible_provisioning-f964f96f607593fbbc561f873c53a203.svg";